import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// About
export const getAbout = () => api.get("/about").then((r) => r.data);
export const updateAbout = (text) => api.put("/about", { text }).then((r) => r.data);

// Delegates
export const getDelegates = () => api.get("/delegates").then((r) => r.data);
export const updateDelegate = (id, data) => api.put(`/delegates/${id}`, data).then((r) => r.data);

// Actions
export const getActions = () => api.get("/actions").then((r) => r.data);
export const getAction = (id) => api.get(`/actions/${id}`).then((r) => r.data);
export const createAction = (data) => api.post("/actions", data).then((r) => r.data);
export const updateAction = (id, data) => api.put(`/actions/${id}`, data).then((r) => r.data);
export const deleteAction = (id) => api.delete(`/actions/${id}`).then((r) => r.data);

// News
export const getNews = () => api.get("/news").then((r) => r.data);
export const getNewsItem = (id) => api.get(`/news/${id}`).then((r) => r.data);
export const createNews = (data) => api.post("/news", data).then((r) => r.data);
export const updateNews = (id, data) => api.put(`/news/${id}`, data).then((r) => r.data);
export const deleteNews = (id) => api.delete(`/news/${id}`).then((r) => r.data);

// Join Info
export const getJoinInfo = () => api.get("/join-info").then((r) => r.data);
export const updateJoinInfo = (data) => api.put("/join-info", data).then((r) => r.data);

// File Upload
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

// Admin Login
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

// Helper to get full upload URL
export const getUploadUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

export default api;
